export default "__VITE_ASSET__qsJM8Z1I__"